<template>
  <div class="welcome-box">
    <div class="left-box">
      <div>

        <header>
          <div>
            <div class="hollow">Hi,<span class="blue">{{userInfo.username}}</span>,早上好</div>
            <div class="date">您已加入学院<span class="blue">{{days}}</span>天啦！</div>
          </div>
          <div>
            <!-- <div class="icon"></div>
          <div class="role">{{userInfo.role}}</div> -->
          </div>
        </header>
        <div class="info-box">
          <div class="doing-box">
            <div class="info-num">{{doing}}</div>
            <div class="info-state">进行中</div>
          </div>
          <div class="done-box">
            <div class="info-num">{{done}}</div>
            <div class="info-state">已完成</div>
          </div>
        </div>
      </div>
      <div class="my-project">
        <div class="title">
          <div class="title-name"><i class="iconfont eltte-doc"></i> <span>我的项目</span> </div>
          <div class="more" @click="goList(2)"><span>查看更多</span> <i class="el-icon-arrow-right"></i></div>
        </div>
        <el-empty v-if="!myProjectList.length" description="暂无相关内容" :image="require('../assets/img/not-content.png')" :image-size="360"></el-empty>
        <div v-else class="projcet-list">
          <div class="project-row">

            <div class="project" v-for="(project,index) in myProjectList" :key='index' @click="goDetail(project.id)">
              <div class="project-name"><img src="../assets/img/file.png" alt="" srcset="">{{project.name}}</div>
              <div class="project-create-time"><i class="el-icon-time"></i> {{project.createTime|dateFormat('YYYY.MM.DD')}}</div>
              <div class="project-node-time"><i class="el-icon-s-operation"></i> {{project.currNodeName||"立项申请"}}
                <el-tag effect="plain" type='danger' v-if="project.currApproveId==userInfo.id&&project.processState==1">待审批</el-tag>
                <el-tag effect="plain" type='danger' v-if="!project.currNodeName||(project.currApproveId==userInfo.id&&project.processState==2)">待提交</el-tag>
              </div>
              <div class="code"><span>编号：{{project.code}}</span><span class="right-now" v-if="(project.currApproveId==userInfo.id&&project.processState==1)||!project.currNodeName||(project.currApproveId==userInfo.id&&project.processState==2)">立即处理</span></div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="right-box">
      <div :class="{'full':!permissGroup.includes('model-home-all-project'),'msg-box':true }">
        <div class="title">
          <div class="title-name"><i class="iconfont eltte-ling"></i> <span>消息</span> </div>
          <!-- <div class="more"><span>查看更多</span> <i class="el-icon-arrow-right"></i></div> -->
        </div>
        <el-empty v-if="!partyProjectList.length" description="暂无相关内容" :image="require('../assets/img/not-content.png')" :image-size="360"></el-empty>
        <div v-else class="msg-list">
          <div class="msg-item" v-for="(item ,index) in partyProjectList" :key="index" @click="goDetail(item.id)">
            <span class="msg-name">{{item.id}} . {{item.name}}</span>
            <span :class="{'msg-state':true,'info':item.processState==1,'success':item.processState==2,'danger':item.processState==3 }">{{statusMap[item.processState]||'已保存'}}</span>
          </div>

        </div>
      </div>
      <div class="all-project" v-has="'model-home-all-project'">
        <div class="title">
          <div class="title-name"><i class="iconfont eltte-file"></i> <span>所有项目</span> </div>
          <div class="more" @click="goList(0)"><span>查看更多</span> <i class="el-icon-arrow-right"></i></div>
        </div>
        <el-empty v-if="!allProjectList.length" description="暂无相关内容" :image="require('../assets/img/not-content.png')" :image-size="360"></el-empty>
        <div v-else class="msg-list">
          <div class="msg-item" v-for="(item ,index) in allProjectList" :key="index" @click="goDetail(item.id)">
            <span class="msg-name">{{item.id}}.{{item.name}}</span>
            <span class="msg-state">{{item.createTime|dateFormat('YYYY/MM/DD')}}</span>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as projectApi from '../api/projectAPI'
import commonData from '../common/commonData'

export default {
  components: {

  },
  props: {

  },
  data() {
    return {
      userInfo: {},
      days: 0,
      myProjectList: [],
      partyProjectList: [],
      allProjectList: [],
      doing: 0,
      done: 0,
      statusMap: {},
      projectStateMap: {},
      permissGroup: []


    };
  },
  computed: {

  },
  watch: {

  },
  async created() {
    this.userInfo = await this.$store.getters.getUserInfo
    console.log("created", this.userInfo)
    this.permissGroup = await this.$store.getters.getPermissionList
    console.log("permissGroup", this.permissGroup);


    let res = await projectApi.list({ form: {}, page: 1, size: 300, type: 1, orderBy: 'apply_time' });
    if (res.flag) {
      this.partyProjectList = res.data.list.length > 20 ? res.data.list.slice(0, 20) : res.data.list
      let myProjectList = res.data.list.filter(p => p.createId == this.userInfo.id).sort((a, b) => {
        return b.id - a.id
      })
      this.doing = myProjectList.filter(p => p.state != 6).length
      this.done = myProjectList.filter(p => p.state == 6).length
      this.myProjectList = myProjectList.length > 12 ? myProjectList.slice(0, 12) : myProjectList
    }
    res = await projectApi.list({ form: {}, page: 1, size: 20, type: 0 });
    if (res.flag) {
      this.allProjectList = res.data.list
    }

  },
  async mounted() {
    this.userInfo =  await this.$store.getters.getUserInfo
    this.statusMap = commonData.approveStatusMap
    this.projectStateMap = commonData.projectState
    var start = moment(this.userInfo.createTime).format('YYYY-MM-DD')
    var end = moment(new Date()).format('YYYY-MM-DD')
    console.log("Home",start,end);
    this.days = moment(end).diff(start, 'day')

  },
  beforeCreate() {
    console.log("beforeCreate", this)
  },
  methods: {
    goDetail(id) {
      this.$router.push("/projectdetail/" + id);
    },
    goList(type) {
      this.$router.push("/projectlist?type=" + type);
    }

  },
};
</script>

<style  lang="less" scoped>
.welcome-box {
  height: 100%;
  position: relative;
  display: flex;
  .left-box {
    flex: 2.4;
    height: calc(100vh);
    display: flex;
    flex-direction: column;
    // padding-bottom: 20px;
    header {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      // height: calc(50vh - 63px);
      .hollow {
        // font-family: PingFang SC;
        font-size: 48px;
        margin-bottom: 10px;
        color: #3d4352;
        letter-spacing: 5px;
        opacity: 1;
      }
      .date {
        font-size: 26px;
        font-weight: 400;
        color: #848a9b;
        opacity: 1;
        letter-spacing: 3px;
      }

      .icon {
        width: 64px;
        height: 64px;
        background: url("../assets/img/zhuanshi.png");
        background-position: center;
        background-size: 100%;
        box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.05);
        border-radius: 50%;
        opacity: 1;
        margin: auto;
        margin-bottom: 10px;
      }
      .role {
        font-size: 16px;
        font-weight: bold;
        color: #f68c00;
        opacity: 1;
      }
    }
    .info-box {
      display: flex;
      > div {
        flex: 1;
        background-color: #fff;
        height: 180px;
        border-radius: 10px;
        margin-top: 30px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        padding-left: 50px;
        > div {
          color: #fff;
        }
      }
      .done-box {
        margin-left: 20px;
        background: url("../assets/img/done-bg.png");
        background-repeat: no-repeat;
        background-size: cover;
      }
      .doing-box {
        background: url("../assets/img/doing-bg.png") no-repeat;
        background-size: cover;
      }
      .info-num {
        font-size: 60px;
      }
      .info-state {
        font-size: 24px;
      }
    }
    .my-project {
      background-color: #fff;
      // height: calc(100vh - 430px);
      // height: fit-content;
      min-height: 320px;
      border-radius: 10px;
      margin-top: 20px;
      overflow-y: auto;
      flex-grow: 1;
      .project-row {
        display: flex;
        padding: 0 10px;
        padding-top: 0;
        flex-wrap: wrap;
        // justify-content: space-between;
        // height: calc(100vh);
        // overflow: auto;

        .project {
          cursor: pointer;
          padding: 15px 20px;
          padding-bottom: 10px;
          border-radius: 5px;
          background: #f4f5f7;
          width: 32.3%;
          font-size: 12px;
          color: #909399;
          margin-bottom: 10px;
          box-sizing: border-box;

          .project-name {
            font-size: 14px;
            color: #303133;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 20px;
              margin-right: 10px;
            }
          }
          .project-create-time,
          .project-node-time {
            margin-bottom: 10px;
            i {
              font-size: 16px;
              margin-right: 10px;
            }
            .el-tag {
              font-size: 12px;
              margin-left: 10px;
              border-radius: 50px;
              padding: 2px 5px;
              height: auto;
              line-height: 1;
            }
          }
          .code {
            display: flex;
            justify-content: space-between;
            .right-now {
              color: #346aff;
            }
          }
        }
        .project:nth-child(3n-1) {
          margin-left: 10px;
          margin-right: 10px;
        }
      }
    }
  }
  .title {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    .title-name {
      display: flex;
      align-items: center;
      i {
        color: #346aff;
        font-size: 24px;
      }
      span {
        font-size: 18px;
        color: #010306;
        font-weight: bold;
        letter-spacing: 2px;
      }
    }
    .more {
      // display: flex;
      // align-items: center;
      font-size: 14px;
      cursor: pointer;
      span {
        color: #aaabab;
      }
      i {
        color: #aaabab;
      }
    }
  }
  .right-box {
    flex: 1;
    display: flex;
    margin-left: 20px;
    flex-direction: column;
    height: calc(100vh);
    .msg-box {
      background-color: #fff;
      min-height: 320px;
      border-radius: 10px;
      overflow-y: auto;
      // margin-bottom: 20px;
      // height: inherit;
    }
    .full {
      height: inherit;
    }
    .msg-list {
      padding: 0 20px;
      .msg-item {
        color: #6f7074;
        display: flex;
        justify-content: space-between;
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
        span {
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        span + span {
          margin-left: 10px;
        }
      }
      .info {
        color: #409eff;
      }
      .success {
        color: #67c23a;
      }
      .danger {
        color: #fc465c;
      }
    }
    .all-project {
      background-color: #fff;
      // height: calc(100vh - 430px);
      border-radius: 10px;
      min-height: 320px;
      overflow-y: auto;
      flex-grow: 1;
      margin-top: 20px;
    }
  }
  .blue {
    color: #346aff;
  }
}
</style>
